import blu from "../img/logos/affiliations/blu_venture.jpeg";
import mach from "../img/logos/affiliations/mach37.jpeg";
import nextgen from "../img/logos/affiliations/NextGen_Venture.png";
import angels from "../img/logos/affiliations/new_dominion_angels.png";
import blue from "../img/logos/affiliations/blue_jay_syndicate.png";

export default [
    blu, mach, nextgen, angels, blue
];